import { render, staticRenderFns } from "./addindex.vue?vue&type=template&id=34a96a44&scoped=true&"
import script from "./addindex.vue?vue&type=script&lang=js&"
export * from "./addindex.vue?vue&type=script&lang=js&"
import style0 from "./addindex.vue?vue&type=style&index=0&id=34a96a44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a96a44",
  null
  
)

export default component.exports